import React from 'react';
import Deliveries from '../components/deliveries'

export default class DeliveriesPage extends React.Component{
	render(){
		return (
            <Deliveries/>
		)
	}
}




// WEBPACK FOOTER //
// ./src/containers/deliveries-page.js